const extractRegex = /^(?:\/([a-z]{2}))?(?:\/consultant\/([^/]+))?(?:\/(.*))?$/;

const run = (slug: string) => {
    const preparedSlug = slug.startsWith('/') ? slug : `/${slug}`;

    const [
        fullPath = '',
        language,
        consultant = '',
        restPath = '',
    ] = preparedSlug.match(extractRegex) || [];

    return {
        fullPath,
        language: language ?? undefined,
        slug: restPath ?? preparedSlug,
        consultantSlug: consultant,
        isConsultantRoute: Boolean(consultant),
    };
};

export const extractConsultantSlug = (slug: string) => run(slug);
